import React from "react";
import { useTranslation } from 'react-i18next';
export default function () {

    const { t } = useTranslation();
    return (
        <div className="text-center">
            <h1 style={{ fontSize: '64px' }}><code>{t("Access Denied")}</code></h1>
            <hr className="border-white m-auto w-50" />
            <h3 className="mt-2">{t("You dont have permission to view this site")}.</h3>
            <h3>🚫🚫🚫🚫</h3>
        </div>
    );
}
 